import React from 'react'
import Can from 'components/Can'
import { Row, Col } from 'react-bootstrap'
import CardItem from './CardItem'
import * as marketingColor from 'images/marketing-color.png'
import * as rebateColor from 'images/rebate-color.png'
import * as statementColor from 'images/statement-color.png'
import { useCompany } from 'models'

export default function SectionEliteOld({fiscalYear}) {
  const {company} = useCompany();

  var items = [
    {
      permission: 'scancash.list.old',
      path: '/elite/scancash/old/'+fiscalYear,
      icon: rebateColor,
      title: 'Fundos de ScanCash ('+fiscalYear+')'
    },
    {
      permission: 'scancash.statement.old',
      path: '/elite/scancash/old/statement/'+fiscalYear,
      icon: statementColor,
      title: 'Extrato ScanCash ('+fiscalYear+')'
    },
  ]

  if (fiscalYear == 2023) {
    items = [...items, ...[
      {
        permission: 'innovation.list.old',
        path: '/elite/innovation/old/'+fiscalYear,
        icon: marketingColor,
        title: 'Fundos de Inovação ('+fiscalYear+')',
        // block_by_company: company&&company.isScancash()
      },
      {
        permission: 'innovation.statement.old',
        path: '/elite/innovation/old/statement/'+fiscalYear,
        icon: statementColor,
        title: 'Extrato Inovação ('+fiscalYear+')',
        // block_by_company: company&&company.isScancash()
      },
    ]]
  }

  return (<>
    <Col sm="12" md="12" lg="12">
      <h6>Elite {fiscalYear}</h6>
    </Col>
    <Row>
      {items.filter(a=>!a.block_by_company).map((item, idx) => {
        return (
          <Can do={item.permission} on="App" key={idx}>
            <CardItem item={item} className={"card-old"}/>
          </Can>
        )
      })}      
    </Row>
  </>)
}